/**
 * PDP — La Europea
 * Gallery, quantity selector, accordion, add-to-cart AJAX, bundling carousel.
 */
(function () {
  'use strict';

  /* ================================================================
     Gallery: thumbnails click (desktop) + mobile swipe/dots
     ================================================================ */
  const gallery = document.querySelector('[data-pdp-gallery]');
  if (gallery) {
    const carousel = gallery.querySelector('[data-pdp-carousel]');
    const slides = gallery.querySelectorAll('[data-pdp-slide]');
    const thumbs = gallery.querySelectorAll('[data-pdp-thumb]');
    const dots = gallery.querySelectorAll('[data-pdp-dot]');
    let currentIdx = 0;

    function goToSlide(idx) {
      if (idx < 0 || idx >= slides.length) return;
      currentIdx = idx;

      // Desktop: toggle is-active class
      slides.forEach(function (s, i) {
        s.classList.toggle('is-active', i === idx);
      });
      thumbs.forEach(function (t, i) {
        t.classList.toggle('is-active', i === idx);
      });
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === idx);
      });

      // Mobile: scroll into view
      if (window.innerWidth < 990 && slides[idx]) {
        slides[idx].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      }
    }

    // Thumbnail clicks
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        goToSlide(parseInt(thumb.dataset.pdpThumb, 10));
      });
    });

    // Dot clicks
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goToSlide(parseInt(dot.dataset.pdpDot, 10));
      });
    });

    // Mobile: IntersectionObserver to sync dots with scroll
    if ('IntersectionObserver' in window && carousel) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              var idx = parseInt(entry.target.dataset.pdpSlide, 10);
              currentIdx = idx;
              dots.forEach(function (d, i) {
                d.classList.toggle('is-active', i === idx);
              });
            }
          });
        },
        { root: carousel, threshold: 0.6 }
      );
      slides.forEach(function (slide) {
        observer.observe(slide);
      });
    }
  }

  /* ================================================================
     Quantity selector (inline + sticky bar synced)
     ================================================================ */
  var qtyWrap = document.querySelector('[data-pdp-qty]');
  var stickyQtyWrap = document.querySelector('[data-pdp-sticky-qty]');
  var qty = 1;

  // Collect all qty displays & inputs to keep in sync
  var qtyDisplays = [];
  var qtyInputs = [];

  if (qtyWrap) {
    qtyDisplays.push(qtyWrap.querySelector('[data-pdp-qty-val]'));
    var inlineInput = document.querySelector('[data-pdp-qty-input]');
    if (inlineInput) qtyInputs.push(inlineInput);
  }
  if (stickyQtyWrap) {
    qtyDisplays.push(stickyQtyWrap.querySelector('[data-pdp-sticky-qty-val]'));
    var stickyInput = document.querySelector('[data-pdp-sticky-qty-input]');
    if (stickyInput) qtyInputs.push(stickyInput);
  }

  function updateQty(n) {
    if (n < 1) n = 1;
    qty = n;
    qtyDisplays.forEach(function (el) { if (el) el.textContent = qty; });
    qtyInputs.forEach(function (el) { if (el) el.value = qty; });
  }

  // Inline qty buttons
  if (qtyWrap) {
    qtyWrap.querySelector('[data-pdp-qty-minus]').addEventListener('click', function () { updateQty(qty - 1); });
    qtyWrap.querySelector('[data-pdp-qty-plus]').addEventListener('click', function () { updateQty(qty + 1); });
  }

  // Sticky qty buttons
  if (stickyQtyWrap) {
    stickyQtyWrap.querySelector('[data-pdp-sticky-qty-minus]').addEventListener('click', function () { updateQty(qty - 1); });
    stickyQtyWrap.querySelector('[data-pdp-sticky-qty-plus]').addEventListener('click', function () { updateQty(qty + 1); });
  }

  /* ================================================================
     Add to Cart — AJAX (shared handler for inline + sticky forms)
     ================================================================ */
  function handleAddToCart(formEl, btnSelector) {
    if (!formEl) return;
    formEl.addEventListener('submit', function (e) {
      e.preventDefault();
      var addBtn = formEl.querySelector(btnSelector);
      var origText = addBtn.textContent.trim();
      addBtn.disabled = true;
      addBtn.textContent = 'Agregando...';

      var formData = new FormData(formEl);
      var body = {};
      formData.forEach(function (v, k) { body[k] = v; });

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(body.id, 10), quantity: parseInt(body.quantity, 10) }] })
      })
        .then(function (res) { return res.json(); })
        .then(function () {
          addBtn.textContent = 'Agregado ✓';
          setTimeout(function () {
            addBtn.textContent = origText;
            addBtn.disabled = false;
          }, 1500);
          document.dispatchEvent(new CustomEvent('cart:updated'));
          // Refresh cart drawer content then open it
          var cartDrawer = document.querySelector('cart-drawer-component');
          var sectionEl = cartDrawer ? cartDrawer.closest('[id^="shopify-section-"]') : null;
          if (sectionEl && cartDrawer) {
            var sectionId = sectionEl.id.replace('shopify-section-', '');
            fetch('/?sections=' + sectionId)
              .then(function (r) { return r.json(); })
              .then(function (sections) {
                if (sections[sectionId]) {
                  sectionEl.innerHTML = new DOMParser()
                    .parseFromString(sections[sectionId], 'text/html')
                    .querySelector('[id="' + sectionEl.id + '"]').innerHTML;
                  var newDrawer = sectionEl.querySelector('cart-drawer-component');
                  if (newDrawer && typeof newDrawer.showDialog === 'function') {
                    newDrawer.showDialog();
                  }
                }
              })
              .catch(function () {
                if (typeof cartDrawer.showDialog === 'function') cartDrawer.showDialog();
              });
          }
        })
        .catch(function () {
          addBtn.textContent = 'Error';
          setTimeout(function () {
            addBtn.textContent = origText;
            addBtn.disabled = false;
          }, 2000);
        });
    });
  }

  handleAddToCart(document.querySelector('[data-pdp-form]'), '[data-pdp-add-btn]');
  handleAddToCart(document.querySelector('[data-pdp-sticky-form]'), '[data-pdp-sticky-add-btn]');

  /* ================================================================
     Accordion
     ================================================================ */
  var accordionToggles = document.querySelectorAll('[data-pdp-accordion-toggle]');
  accordionToggles.forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      var item = toggle.closest('.le-pdp__accordion-item');
      var body = item.querySelector('[data-pdp-accordion-body]');
      var isOpen = item.classList.contains('is-open');

      if (isOpen) {
        body.style.maxHeight = '0';
        item.classList.remove('is-open');
      } else {
        body.style.maxHeight = body.scrollHeight + 'px';
        item.classList.add('is-open');
      }
    });
  });

  /* ================================================================
     "Ver disponibilidad en tienda" — opens the pickup dialog (left drawer)
     Requests geolocation and sorts stores by distance
     ================================================================ */
  function haversineKm(lat1, lng1, lat2, lng2) {
    var R = 6371;
    var dLat = (lat2 - lat1) * Math.PI / 180;
    var dLng = (lng2 - lng1) * Math.PI / 180;
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
      Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  function getSucursalesGeoMap() {
    var el = document.getElementById('le-sucursales-data');
    var map = {};
    if (!el) return map;
    try {
      var arr = JSON.parse(el.textContent);
      arr.forEach(function (s) {
        var lat = parseFloat(s.lat);
        var lng = parseFloat(s.lng);
        if (!isNaN(lat) && !isNaN(lng) && s.id != null) {
          map[String(s.id)] = { lat: lat, lng: lng };
        }
      });
    } catch (e) {}
    return map;
  }

  function sortPickupDialogByDistance() {
    var dialog = document.querySelector('.le-pdp__pickup-dialog');
    if (!dialog) return;
    var body = dialog.querySelector('.le-pdp__pickup-dialog-body');
    if (!body) return;

    if (!navigator.geolocation) return;

    var geoMap = getSucursalesGeoMap();
    if (Object.keys(geoMap).length === 0) return;

    navigator.geolocation.getCurrentPosition(function (pos) {
      var userLat = pos.coords.latitude;
      var userLng = pos.coords.longitude;
      var locs = Array.prototype.slice.call(body.querySelectorAll('.le-pdp__pickup-dialog-location'));

      locs.forEach(function (el) {
        var locId = el.getAttribute('data-location-id');
        var geo = geoMap[String(locId)];
        if (geo) {
          var d = haversineKm(userLat, userLng, geo.lat, geo.lng);
          el._dist = d;
          var info = el.querySelector('.le-pdp__pickup-dialog-location-info');
          if (info) {
            var existing = info.querySelector('.le-pdp__pickup-dialog-distance');
            if (existing) existing.remove();
            var p = document.createElement('p');
            p.className = 'le-pdp__pickup-dialog-distance';
            p.textContent = 'A ' + d.toFixed(1) + ' km de tu ubicación';
            info.appendChild(p);
          }
        } else {
          el._dist = Infinity;
        }
      });

      locs.sort(function (a, b) {
        return (a._dist || Infinity) - (b._dist || Infinity);
      });
      locs.forEach(function (el) { body.appendChild(el); });
    }, function () {}, { timeout: 10000, maximumAge: 300000 });
  }

  var availabilityBtn = document.querySelector('[data-le-open-pickup-dialog]');
  if (availabilityBtn) {
    availabilityBtn.addEventListener('click', function () {
      var dialog = document.querySelector('.le-pdp__pickup-dialog');
      if (dialog && dialog.showModal) {
        dialog.showModal();
        sortPickupDialogByDistance();
      }
    });
  }

  /* ================================================================
     Bundling carousel — fetches via section rendering for metafield access
     ================================================================ */
  var bundling = document.querySelector('[data-pdp-bundling]');
  if (bundling) {
    var track = bundling.querySelector('[data-pdp-bundling-track]');
    var prevBtn = bundling.querySelector('[data-pdp-bundling-prev]');
    var nextBtn = bundling.querySelector('[data-pdp-bundling-next]');
    var bundlingIdx = 0;
    var totalCards = 0;

    function initBundlingCards() {
      var cards = track.querySelectorAll('.le-pdp__bundling-card');
      totalCards = cards.length;
      if (totalCards === 0) {
        bundling.style.display = 'none';
        return;
      }
      updateBundlingArrows();
    }

    function slideBundling(dir) {
      bundlingIdx += dir;
      if (bundlingIdx < 0) bundlingIdx = 0;
      if (bundlingIdx >= totalCards) bundlingIdx = totalCards - 1;
      track.style.transform = 'translateX(-' + (bundlingIdx * 100) + '%)';
      updateBundlingArrows();
    }

    function updateBundlingArrows() {
      prevBtn.disabled = bundlingIdx <= 0;
      nextBtn.disabled = bundlingIdx >= totalCards - 1;
    }

    prevBtn.addEventListener('click', function () { slideBundling(-1); });
    nextBtn.addEventListener('click', function () { slideBundling(1); });

    // Fetch complementary recommendations via section rendering (gives metafield access)
    var productId = bundling.dataset.productId;
    if (productId) {
      fetch('/recommendations/products?product_id=' + productId + '&limit=6&intent=complementary&section_id=section-bundling-cards-le')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var cards = doc.querySelector('[data-bundling-cards]');
          if (cards && cards.innerHTML.trim() !== '') {
            track.innerHTML = cards.innerHTML;
            initBundlingCards();
          } else {
            bundling.style.display = 'none';
          }
        })
        .catch(function () {
          bundling.style.display = 'none';
        });
    }
  }
})();
